import type { PersonFormValues } from '../../../../models/person/PersonModel';
import type { IPerson } from '../../../../models/person/PersonModel';

export const formatPhoneMask = (value: string): string => {
  const numbers = value.replace(/\D/g, '');

  if (numbers.length <= 3) {
    return numbers.length > 0 ? `(${numbers}` : '';
  }

  if (numbers.length <= 6) {
    return `(${numbers.slice(0, 3)}) ${numbers.slice(3)}`;
  }

  if (numbers.length <= 8) {
    return `(${numbers.slice(0, 3)}) ${numbers.slice(3, 6)} ${numbers.slice(6)}`;
  }

  return `(${numbers.slice(0, 3)}) ${numbers.slice(3, 6)} ${numbers.slice(6, 8)} ${numbers.slice(8, 10)}`;
};

export const getEditPersonFormValues = (person: IPerson): PersonFormValues => {
  return {
    name: person.name || '',
    hospitalId: person.hospitalId ?? null,
    phoneNumber: person.phoneNumber || '',
    email: person.email || '',
  };
};
